export const SET_HISTORY = 'SET_HISTORY';